import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import survey from "../../../images/survey.png";
import quiz from "../../../images/quiz.png";
import chat from "../../../images/chat.png";
import headset from "../../../images/headset.png";
import award from "../../../images/award.png";
import play from "../../../images/play.png";
import todo from "../../../images/todo.png";
import announcement from "../../../images/announcement.png";
import eMagazine from "../../../images/e-magazine.png";
import faq from "../../../images/faq.png";
import feedback from "../../../images/feedback.png";
import ideaboard from "../../../images/ideaboard.png";
import sos from "../../../images/sos.png";
import virtualEvent from "../../../images/virtual-event.png";
import ModuleThumb from "../../ui/ModuleThumb";
import { getProfile } from "../../../store/authMethods";
import { useDispatch, useSelector } from "react-redux";

function Thub() {
  const dispatch = useDispatch();
  const profileData = useSelector((state) => state.auth.myProfile);

  return (
    <Container className="mainContent">
      <Row className="justify-content-center">
        <Col xs={10} md={8}>
          <Row className="row-cols-2 row-cols-md-3 row-cols-lg-4 g-4 g-lg-5 justify-content-center">
            <Col>
              <ModuleThumb url="/survey" image={survey} />
            </Col>
            <Col>
              <ModuleThumb url="/quiz" image={quiz} />
            </Col>
            <Col>
              <ModuleThumb url="/chat" image={chat} />
            </Col>
            <Col>
              <ModuleThumb url="/helpdesk" image={headset} />
            </Col>
            <Col>
              <ModuleThumb url="/hall-of-fame" image={award} />
            </Col>
            <Col>
              <ModuleThumb url="/games" image={play} />
            </Col>
            <Col>
              <ModuleThumb url="/todolist" image={todo} />
            </Col>
            <Col>
              <ModuleThumb url="/virtual-event" image={virtualEvent} />
            </Col>
            <Col>
              <ModuleThumb url="/sos" image={sos} />
            </Col>
            <Col>
              <ModuleThumb url="/ideaboard" image={ideaboard} />
            </Col>
            {/* <Col>
              <ModuleThumb url="/feedback" image={feedback} />
            </Col> */}
            <Col>
              <ModuleThumb url="/faq" image={faq} />
            </Col>
            <Col>
              <ModuleThumb url="/e-magazine" image={eMagazine} />
            </Col>
            <Col>
              <ModuleThumb url="/announcements" image={announcement} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Thub;
